/**
 * Đọc tệp CSV / chữ do chủ tiệm chọn (STT 2.2) — thuần, không thư viện, không `.xlsx`.
 *
 * Excel "CSV" thường lưu bảng mã Windows (tiếng Việt: windows-1258, dấu tách rời), "CSV UTF-8" lưu UTF-8 có
 * BOM, "Unicode Text" lưu UTF-16. Đọc đúng BOM trước; không có BOM thì thử UTF-8 nghiêm ngặt, hỏng mới rơi về
 * windows-1258 rồi gộp dấu về NFC — và BÁO để chủ tiệm xem kỹ dấu của tên.
 */
export const TEP_TOI_DA_BYTE = 1024 * 1024

export type KetQuaDocTep =
  | { ok: true; chu: string; khongPhaiUtf8: boolean }
  | { ok: false; loi: 'QUA_LON' | 'KHONG_DOC_DUOC' }

export function docBangMaTep(buf: ArrayBuffer): KetQuaDocTep {
  if (buf.byteLength > TEP_TOI_DA_BYTE) return { ok: false, loi: 'QUA_LON' }
  const b = new Uint8Array(buf)
  try {
    if (b.length >= 3 && b[0] === 0xef && b[1] === 0xbb && b[2] === 0xbf) {
      return { ok: true, chu: new TextDecoder('utf-8').decode(b), khongPhaiUtf8: false }
    }
    if (b.length >= 2 && b[0] === 0xff && b[1] === 0xfe) {
      return { ok: true, chu: new TextDecoder('utf-16le').decode(b), khongPhaiUtf8: false }
    }
    if (b.length >= 2 && b[0] === 0xfe && b[1] === 0xff) {
      return { ok: true, chu: new TextDecoder('utf-16be').decode(b), khongPhaiUtf8: false }
    }
    try {
      return {
        ok: true,
        chu: new TextDecoder('utf-8', { fatal: true }).decode(b),
        khongPhaiUtf8: false,
      }
    } catch {
      // Không phải UTF-8: đọc theo bảng mã tiếng Việt của Windows.
      const chu = new TextDecoder('windows-1258').decode(b).normalize('NFC')
      return { ok: true, chu, khongPhaiUtf8: true }
    }
  } catch {
    return { ok: false, loi: 'KHONG_DOC_DUOC' }
  }
}
